import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import history from '../../utils/history';

class NotificationPopUp extends React.Component {
  handleClick = () => {
    if (!this.props.mainButtonFunction) {
      this.props.buttonLink
        ? history.push(this.props.buttonLink)
        : history.push('/app/manage-subscription');
      this.props.openCancelPopUp(false);
    } else {
      this.props.mainButtonFunction();
    }
  };

  handleOnClose = () => {
    if (
      this.props.notificationInformation &&
      this.props.notificationInformation.closeRedirect
    ) {
      this.props.openCancelPopUp(false);
      history.push(this.props.notificationInformation.closeRedirect);
    } else {
      this.props.openCancelPopUp(false);
    }
  };

  render() {
    let paymentFailed = false;
    if (this.props.user) {
      paymentFailed = this.props.user.chargeFailed;
    }

    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          toggle={this.props.dontToggle ? () => {} : this.handleOnClose}
          className="suscription-expired subscription-expired-free modal-dialog-centered"
        >
          <ModalHeader tag="div" toggle={this.toggle} className="danger">
            <i className="icon-lock big-icon" />
            <i
              className="icon-close close cancel-close"
              onClick={this.handleOnClose}
            />

            <h4>
              {this.props.notificationInformation
                ? this.props.notificationInformation.notificationTitle
                : 'Subscription Expired'}
            </h4>
          </ModalHeader>
          <ModalBody data-test={this.props.dataTest}>
            {this.props.notificationInformation
              ? this.props.notificationInformation.notificationDescription
              : 'For full study access, renew your subscription.'}
          </ModalBody>
          <ModalBody className="message-error">
            {paymentFailed &&
              'There was a problem with the payment method. Please contact your bank.'}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" size="xs" block onClick={this.handleClick}>
              {this.props.notificationInformation
                ? this.props.notificationInformation.mainButtonLabel
                : 'MANAGE MY SUBSCRIPTION'}
            </Button>{' '}
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default NotificationPopUp;
